import React from "react";
import InputIcon from "../../components/Input/InputIcon";
import building from "../../assets/icons/building-02.svg";
import mail from "../../assets/icons/mail-icon.svg";
import user from "../../assets/icons/user-01.svg";
import phone from "../../assets/icons/phone-01.svg";

export default function AccountDetailsFragment({ dataUser, dataAccount }) {
  return (
    <div>
      <form className="mt-4 space-y-3">
        <InputIcon
          placeholder="Admin Email"
          icon={mail}
          label="Email Administrator"
          value={dataUser?.identifier ?? ""}
          disabled
        />
        <InputIcon
          placeholder="Admin Full Name"
          label="Nama Administrator"
          icon={user}
          value={
            dataUser?.profile?.firstName + " " + dataUser?.profile?.lastName
          }
          disabled
        />
        <InputIcon
          icon={phone}
          value={`+${dataUser?.profile?.phone}` ?? ""}
          label="Nomor WhatsApp"
          disabled
        />
        <InputIcon
          icon={building}
          label="Nama Akun"
          placeholder="Account Name"
          value={dataAccount?.name ?? ""}
          disabled
        />
      </form>
    </div>
  );
}
